import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Calculator } from "lucide-react";

const CAMPI = [["stato_ristrutturare", "Da ristrutturare: % sul minimo OMI"], ["stato_nuovo", "Nuovo: % sul massimo OMI"],
  ["piano_terra", "Piano terra %"], ["piano_alto_asc", "Piano alto con ascensore %"], ["piano_alto_no_asc", "Piano alto senza ascensore %"],
  ["classe_ab", "Classe A/B %"], ["classe_ef", "Classe E/F %"], ["classe_g", "Classe G %"], ["espo_scarsa", "Luminosità scarsa %"],
  ["espo_ottima", "Luminosità ottima %"], ["esterni", "Spazi esterni di pregio %"], ["limite", "Limite totale correttivi ±%"],
  ["box", "Box auto € (predefinito)"], ["posto", "Posto auto € (predefinito)"]];

export default function ValuArtConfigCard() {
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/valuart/config").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return null;
  const salva = async () => {
    setBusy(true);
    try { const r = await api.put("/valuart/config", c); setC(r.data); toast.success("Impostazioni VALU-ART salvate"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-immo p-5" data-testid="valuart-config-card">
      <div className="flex items-center gap-2 mb-3"><span className="w-8 h-8 rounded-xl bg-[#FC82ED]/15 text-[#FC82ED] flex items-center justify-center"><Calculator size={16} /></span><h2 className="font-display font-bold text-base">VALU-ART</h2></div>
      <div className="grid sm:grid-cols-2 gap-2">{CAMPI.map(([k, l]) => (
        <label key={k} className="block text-xs text-[var(--muted)]">{l}
          <input data-testid={`valuart-cfg-${k}`} value={c[k] ?? ""} onChange={(e) => setC({ ...c, [k]: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[var(--border)] text-sm text-[#111111]" /></label>))}</div>
      <button data-testid="valuart-cfg-salva" onClick={salva} disabled={busy} className="mt-3 px-4 py-2 rounded-xl bg-[#111111] text-white text-sm font-semibold disabled:opacity-50">Salva</button>
    </div>
  );
}
